export default __webpack_public_path__ + "media/8d85df53f3207db60ac24a37e6259e25df22450881e55bada0ef60fc8125b767.svg";